
import {Component, Vue} from 'vue-property-decorator';
import {alertModule, AlertOptions} from '@/store/modules/alert';

@Component
export default class AppFlashMessage extends Vue {
  @alertModule.State('options') alert!: AlertOptions;
}
